<template>
  <td v-if="!activeComponent">
    <button
      type="button"
      class="btn btn-primary btn-sm"
      @click="
        selectAction('AdminTableChangeEmailButton');
        setError(null);
      "
    >
      Change Email
    </button>
    <span class="border-start border-primary mx-2" />
    <button
      type="button"
      class="btn btn-primary btn-sm"
      @click="
        selectAction('AdminTableChangePasswordButton');
        setError(null);
      "
    >
      Change Password
    </button>
    <span class="border-start border-primary mx-2" />
    <button
      type="button"
      class="btn btn-danger btn-sm"
      @click="
        selectAction('AdminTableDeleteUserButton');
        setError(null);
      "
    >
      Delete User
    </button>
  </td>

  <td v-else>
    <component
      :is="activeComponent"
      :set-error="setError"
      :record-id="recordId"
      :deactivate-component-func="deactivateAction"
      :recreate-table-func="recreateTableFunc"
    />
  </td>
</template>

<script lang="ts">
import AdminTableChangePasswordButton from '@/components/AdminTableChangePasswordButton.vue';
import AdminTableChangeEmailButton from '@/components/AdminTableChangeEmailButton.vue';
import AdminTableDeleteUserButton from '@/components/AdminTableDeleteUserButton.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AdminTableActionButtons',

  components: {
    AdminTableChangePasswordButton,
    AdminTableChangeEmailButton,
    AdminTableDeleteUserButton,
  },

  props: {
    recordId: {
      type: Number,
      required: true,
    },
    recreateTableFunc: {
      type: Function,
      required: true,
    },
    setError: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      activeComponent: null as string | null,
    };
  },

  methods: {
    async selectAction(actionName: string | null) {
      this.activeComponent = actionName;
    },

    async deactivateAction() {
      this.activeComponent = null;
    },
  },
});
</script>
